import fetchRequest from '../util/fetch'
import errUtil from '../util/error'

const query = `mutation RoleDeleteMutation (
  $workspace: ID!,
  $user: ID!
) {
  roleDelete (
    workspace: $workspace
    user: $user
  ) {
    id
  }
}`

async function requestRoleDelete (variables, token) {
  const response = await fetchRequest({
    variables,
    query,
    token
  })
  if (!response) return errUtil.noResponse()

  const { errors, data } = response
  if (errors) {
    return errUtil.apiError('role-delete', errors)
  }
  return data.roleDelete
}

export default requestRoleDelete
